import { OptimusTextKey } from './OptimusTextKey';

export const isOptimusTextKey = (textKey: string): textKey is OptimusTextKey => textKey in OptimusTextKey;
